<template>
  <span :aria-hidden="decorative"
        :aria-label="title"
        class="material-design-icon account-icon"
        role="img">

    <svg class="material-design-icon__svg" :width="size" :height="size" viewBox="0 0 24 24">
      <path :fill="fillColor" d="M14,2L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2H14M18,20V9H13V4H6V20H18M11.2,18.46L8.45,15.46L9.61,14.3L11.2,15.88L14.78,12.3L15.95,13.71L11.2,18.46Z" />
  </svg>

  </span>
</template>

<script>
export default {
  name: "EditIcon",
  props: {
    title: {
      type: String,
      default: "Edit icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
}
</script>
